// extracted by mini-css-extract-plugin
module.exports = {"wrapper_19rtJ6":"wrapper_19rtJ6","icon_1ZiSbI":"icon_1ZiSbI"};